module.exports = __webpack_public_path__ + "static/w-fujitsu-content-marketing-fee569fb2fee177bc841f3bc38a543af.webp";